// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Task board (Tasks page, ticket workflow drawer, employee profile,
   milestone). Mobile first: phones get one column per screen that
   snaps sideways; tablets scroll a row of fixed-width columns;
   wide desktops show all four columns as a grid.
   ============================================================ */

.desk-wrapper {
  padding: var(--ds-space-3);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
}

/* Inside a drawer or a profile tab the surrounding container already gives the padding. */
.desk-wrapper--embedded {
  padding: 0;
  background: transparent;
  border: none;
}

.desk-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-4);
}

.desk-topbar__left {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  min-width: 0;
  flex: 1;
}

.desk-topbar__title {
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--ds-title-size);
  font-weight: 700;
  color: var(--ds-text);
}

.desk-topbar__count {
  flex-shrink: 0;
  background: var(--ds-surface-muted);
  color: var(--ds-text-2);
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
}

/* ── Column switcher (phones) ─────────────────────────────── */
.desk-switcher {
  margin-bottom: var(--ds-space-3);
  overflow-x: auto;
  scrollbar-width: none;
}

.desk-switcher::-webkit-scrollbar {
  display: none;
}

.desk-switcher__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
}

/* ── Board ────────────────────────────────────────────────── */
.desk-board {
  display: flex;
  gap: var(--ds-space-3);
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px;
  scrollbar-width: thin;
  scrollbar-color: var(--ds-border) transparent;
}

.desk-column {
  flex: 0 0 85vw;
  max-width: 360px;
  scroll-snap-align: start;
  background: var(--ds-bg);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  overflow: hidden;
  min-width: 0;
}

/* Fitted board (height set by TaskBoard): the page stays put and each column scrolls. */
.desk-board--fit {
  align-items: stretch;
}

.desk-board--fit .desk-column {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.desk-board--fit .desk-column__body {
  flex: 1;
  min-height: 0;
  max-height: none;
}

.desk-column__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
  padding: 12px 14px 10px;
  background: var(--ds-surface);
  border-top: 3px solid transparent;
}

.desk-column__head-left {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: 0;
}

.desk-column__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.desk-column__name {
  font-size: 14px;
  font-weight: 700;
  color: var(--ds-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.desk-column__badge {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}

.desk-column__body {
  padding: 10px;
  min-height: 200px;
  max-height: 68vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  transition: background 0.2s;
  scrollbar-width: thin;
  scrollbar-color: var(--ds-border) transparent;
}

.desk-column__body--over {
  background: var(--ds-brand-tint);
}

.desk-column__empty {
  text-align: center;
  color: var(--ds-text-muted);
  font-size: 13px;
  padding: var(--ds-space-8) var(--ds-space-2);
  border: 2px dashed var(--ds-border);
  border-radius: var(--ds-radius-md);
  margin: 4px;
}

/* ── Card ─────────────────────────────────────────────────── */
.desk-card {
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  padding: var(--ds-space-3);
  box-shadow: var(--ds-shadow-xs);
  cursor: grab;
  transition:
    box-shadow 0.15s ease,
    transform 0.15s ease;
  user-select: none;
  min-width: 0;
}

.desk-card--dragging {
  box-shadow: var(--ds-shadow-lg);
  transform: rotate(1.5deg) scale(1.02);
  cursor: grabbing;
}

.desk-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
  margin-bottom: 10px;
}

.desk-card__header .ant-tag {
  margin: 0;
}

.desk-card__date {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--ds-text-muted);
  white-space: nowrap;
}

.desk-card__title {
  margin: 0 0 10px;
  overflow-wrap: anywhere;
  font-size: 14px;
  font-weight: 700;
  color: var(--ds-text);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.desk-card__desc {
  margin: -4px 0 10px;
  font-size: 12px;
  color: var(--ds-text-2);
  line-height: 1.5;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.desk-card__leader {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: var(--ds-space-3);
  min-width: 0;
}

.desk-card__leader-name {
  font-size: 12px;
  color: var(--ds-text-2);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Timer (ticket workflow) */
.desk-card__timer {
  background: var(--ds-surface-muted);
  border-radius: var(--ds-radius-md);
  padding: 10px;
  margin-bottom: 10px;
}

.desk-card__times {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.desk-card__time {
  display: flex;
  flex-direction: column;
  min-width: 0;
  font-size: 10px;
  color: var(--ds-text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.desk-card__time strong {
  font-size: 13px;
  color: var(--ds-text);
  text-transform: none;
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.desk-card__time.is-active strong {
  color: var(--ds-brand-strong);
}

.desk-card__timer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.desk-card__timer-actions .desk-timer-btn {
  flex: 1 1 0;
  min-width: 0;
  box-shadow: none;
}

.desk-card__timer-actions .desk-timer-btn.is-stop {
  flex: 0 0 auto;
}

/* Footer: team + actions */
.desk-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  padding-top: 10px;
  border-top: 1px solid var(--ds-border-soft);
}

.desk-card__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
  margin-inline-start: auto;
}

.desk-card__actions .desk-card__icon-btn {
  color: var(--ds-text-2);
}

.desk-card__actions .desk-card__icon-btn.ant-btn-dangerous {
  color: var(--ds-danger);
}

.desk-card__status {
  min-width: 0;
  max-width: 150px;
}

/* ── Task details dialog (ShowDrawer) ─────────────────────── */
.task-details-modal .task-details__head {
  padding-bottom: var(--ds-space-3);
  border-bottom: 1px solid var(--ds-border-soft);
}

.task-details-modal .task-details__title {
  margin: 0 0 var(--ds-space-2);
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--ds-text);
  overflow-wrap: anywhere;
}

.task-details-modal .task-details__tags,
.task-details-modal .task-details__inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.task-details-modal .task-details__tags .ant-tag,
.task-details-modal .task-details__inline .ant-tag {
  margin: 0;
}

.task-details-modal .task-details__row {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-3);
  padding: var(--ds-space-3) 0;
  border-bottom: 1px solid var(--ds-border-soft);
}

.task-details-modal .task-details__row:last-child {
  border-bottom: none;
}

.task-details-modal .task-details__icon {
  width: 34px;
  height: 34px;
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ds-brand-strong);
  font-size: 15px;
  flex-shrink: 0;
}

.task-details-modal .task-details__body {
  flex: 1;
  min-width: 0;
}

.task-details-modal .task-details__label {
  margin: 0;
  font-size: 11px;
  color: var(--ds-text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.task-details-modal .task-details__value {
  margin-top: 3px;
}

.task-details-modal .task-details__strong {
  font-size: 14px;
  font-weight: 600;
  color: var(--ds-text);
  overflow-wrap: anywhere;
}

.task-details-modal .task-details__muted {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.task-details-modal .task-details__text {
  margin: 0;
  font-size: 13px;
  color: var(--ds-text-2);
  line-height: 1.7;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* ── Phones: flat board, touch-sized card controls ────────── */
@media (max-width: 767.98px) {
  /* No card-in-card: the page background is the board, columns are plain lists. */
  .desk-wrapper:not(.desk-wrapper--embedded) {
    padding: 0;
    background: transparent;
    border: 0;
  }

  .desk-column {
    flex-basis: 100%;
    max-width: none;
    background: transparent;
    border: 0;
    border-radius: 0;
  }

  .desk-column__head {
    display: none;
  }

  .desk-column__body {
    padding-inline: 0 !important;
  }

  .desk-switcher .ant-segmented {
    padding: 3px;
    border-radius: 12px;
  }

  .desk-switcher .ant-segmented-item-label {
    padding-inline: 12px;
  }

  .desk-switcher .desk-column__badge {
    line-height: 16px;
    padding: 1px 7px;
  }

  .desk-card .ant-btn {
    min-height: 40px;
  }

  .desk-card .desk-card__icon-btn {
    min-width: 40px;
  }

  .desk-card__actions {
    gap: var(--ds-space-1);
  }
}

/* ── Tablets and up ───────────────────────────────────────── */
@media (min-width: 768px) {
  .desk-wrapper {
    padding: var(--ds-space-5);
  }

  .desk-wrapper--embedded {
    padding: 0;
  }

  .desk-board {
    gap: var(--ds-space-4);
    scroll-snap-type: x proximity;
  }

  .desk-column {
    flex: 0 0 300px;
    max-width: none;
  }
}

/* Wide screens: all four columns fit, so they share the width. */
@media (min-width: 1200px) {
  .desk-board {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    overflow: visible;
    padding-bottom: 0;
  }

  .desk-board:not(.desk-board--fit) {
    align-items: start;
  }
}

/* Hover lift only where there is a pointer that hovers. */
@media (hover: hover) {
  .desk-card:hover {
    box-shadow: var(--ds-shadow-md);
    transform: translateY(-1px);
  }

  .desk-card__actions .desk-card__icon-btn:hover {
    color: var(--ds-brand-strong);
  }

  .desk-card__actions .desk-card__icon-btn.ant-btn-dangerous:hover {
    color: var(--ds-danger);
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/tasks/tasks.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA,0FAA0F;AAC1F;EACE,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;AACd;;AAEA,wFAAwF;AACxF;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,4CAA4C;EAC5C,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;EAC1B,+BAA+B;EAC/B,YAAY;EACZ;;wBAEsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,gEAAgE;AAChE;EACE,gFAAgF;EAChF;IACE,UAAU;IACV,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ============================================================\n   Task board (Tasks page, ticket workflow drawer, employee profile,\n   milestone). Mobile first: phones get one column per screen that\n   snaps sideways; tablets scroll a row of fixed-width columns;\n   wide desktops show all four columns as a grid.\n   ============================================================ */\n\n.desk-wrapper {\n  padding: var(--ds-space-3);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n}\n\n/* Inside a drawer or a profile tab the surrounding container already gives the padding. */\n.desk-wrapper--embedded {\n  padding: 0;\n  background: transparent;\n  border: none;\n}\n\n.desk-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-4);\n}\n\n.desk-topbar__left {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  min-width: 0;\n  flex: 1;\n}\n\n.desk-topbar__title {\n  margin: 0;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--ds-title-size);\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n.desk-topbar__count {\n  flex-shrink: 0;\n  background: var(--ds-surface-muted);\n  color: var(--ds-text-2);\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 999px;\n}\n\n/* ── Column switcher (phones) ─────────────────────────────── */\n.desk-switcher {\n  margin-bottom: var(--ds-space-3);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.desk-switcher::-webkit-scrollbar {\n  display: none;\n}\n\n.desk-switcher__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 36px;\n}\n\n/* ── Board ────────────────────────────────────────────────── */\n.desk-board {\n  display: flex;\n  gap: var(--ds-space-3);\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-snap-type: x mandatory;\n  overscroll-behavior-x: contain;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 6px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--ds-border) transparent;\n}\n\n.desk-column {\n  flex: 0 0 85vw;\n  max-width: 360px;\n  scroll-snap-align: start;\n  background: var(--ds-bg);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  overflow: hidden;\n  min-width: 0;\n}\n\n/* Fitted board (height set by TaskBoard): the page stays put and each column scrolls. */\n.desk-board--fit {\n  align-items: stretch;\n}\n\n.desk-board--fit .desk-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.desk-board--fit .desk-column__body {\n  flex: 1;\n  min-height: 0;\n  max-height: none;\n}\n\n.desk-column__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  padding: 12px 14px 10px;\n  background: var(--ds-surface);\n  border-top: 3px solid transparent;\n}\n\n.desk-column__head-left {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-width: 0;\n}\n\n.desk-column__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.desk-column__name {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ds-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.desk-column__badge {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n\n.desk-column__body {\n  padding: 10px;\n  min-height: 200px;\n  max-height: 68vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  transition: background 0.2s;\n  scrollbar-width: thin;\n  scrollbar-color: var(--ds-border) transparent;\n}\n\n.desk-column__body--over {\n  background: var(--ds-brand-tint);\n}\n\n.desk-column__empty {\n  text-align: center;\n  color: var(--ds-text-muted);\n  font-size: 13px;\n  padding: var(--ds-space-8) var(--ds-space-2);\n  border: 2px dashed var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  margin: 4px;\n}\n\n/* ── Card ─────────────────────────────────────────────────── */\n.desk-card {\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  padding: var(--ds-space-3);\n  box-shadow: var(--ds-shadow-xs);\n  cursor: grab;\n  transition:\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n  user-select: none;\n  min-width: 0;\n}\n\n.desk-card--dragging {\n  box-shadow: var(--ds-shadow-lg);\n  transform: rotate(1.5deg) scale(1.02);\n  cursor: grabbing;\n}\n\n.desk-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  margin-bottom: 10px;\n}\n\n.desk-card__header .ant-tag {\n  margin: 0;\n}\n\n.desk-card__date {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: var(--ds-text-muted);\n  white-space: nowrap;\n}\n\n.desk-card__title {\n  margin: 0 0 10px;\n  overflow-wrap: anywhere;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ds-text);\n  line-height: 1.45;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.desk-card__desc {\n  margin: -4px 0 10px;\n  font-size: 12px;\n  color: var(--ds-text-2);\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.desk-card__leader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: var(--ds-space-3);\n  min-width: 0;\n}\n\n.desk-card__leader-name {\n  font-size: 12px;\n  color: var(--ds-text-2);\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Timer (ticket workflow) */\n.desk-card__timer {\n  background: var(--ds-surface-muted);\n  border-radius: var(--ds-radius-md);\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n.desk-card__times {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.desk-card__time {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  font-size: 10px;\n  color: var(--ds-text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.desk-card__time strong {\n  font-size: 13px;\n  color: var(--ds-text);\n  text-transform: none;\n  letter-spacing: 0;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.desk-card__time.is-active strong {\n  color: var(--ds-brand-strong);\n}\n\n.desk-card__timer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.desk-card__timer-actions .desk-timer-btn {\n  flex: 1 1 0;\n  min-width: 0;\n  box-shadow: none;\n}\n\n.desk-card__timer-actions .desk-timer-btn.is-stop {\n  flex: 0 0 auto;\n}\n\n/* Footer: team + actions */\n.desk-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  padding-top: 10px;\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.desk-card__actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  min-width: 0;\n  margin-inline-start: auto;\n}\n\n.desk-card__actions .desk-card__icon-btn {\n  color: var(--ds-text-2);\n}\n\n.desk-card__actions .desk-card__icon-btn.ant-btn-dangerous {\n  color: var(--ds-danger);\n}\n\n.desk-card__status {\n  min-width: 0;\n  max-width: 150px;\n}\n\n/* ── Task details dialog (ShowDrawer) ─────────────────────── */\n.task-details-modal .task-details__head {\n  padding-bottom: var(--ds-space-3);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.task-details-modal .task-details__title {\n  margin: 0 0 var(--ds-space-2);\n  font-size: 1.15rem;\n  font-weight: 700;\n  line-height: 1.35;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n}\n\n.task-details-modal .task-details__tags,\n.task-details-modal .task-details__inline {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.task-details-modal .task-details__tags .ant-tag,\n.task-details-modal .task-details__inline .ant-tag {\n  margin: 0;\n}\n\n.task-details-modal .task-details__row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--ds-space-3);\n  padding: var(--ds-space-3) 0;\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.task-details-modal .task-details__row:last-child {\n  border-bottom: none;\n}\n\n.task-details-modal .task-details__icon {\n  width: 34px;\n  height: 34px;\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ds-brand-strong);\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.task-details-modal .task-details__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.task-details-modal .task-details__label {\n  margin: 0;\n  font-size: 11px;\n  color: var(--ds-text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.task-details-modal .task-details__value {\n  margin-top: 3px;\n}\n\n.task-details-modal .task-details__strong {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n}\n\n.task-details-modal .task-details__muted {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.task-details-modal .task-details__text {\n  margin: 0;\n  font-size: 13px;\n  color: var(--ds-text-2);\n  line-height: 1.7;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n/* ── Phones: flat board, touch-sized card controls ────────── */\n@media (max-width: 767.98px) {\n  /* No card-in-card: the page background is the board, columns are plain lists. */\n  .desk-wrapper:not(.desk-wrapper--embedded) {\n    padding: 0;\n    background: transparent;\n    border: 0;\n  }\n\n  .desk-column {\n    flex-basis: 100%;\n    max-width: none;\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .desk-column__head {\n    display: none;\n  }\n\n  .desk-column__body {\n    padding-inline: 0 !important;\n  }\n\n  .desk-switcher .ant-segmented {\n    padding: 3px;\n    border-radius: 12px;\n  }\n\n  .desk-switcher .ant-segmented-item-label {\n    padding-inline: 12px;\n  }\n\n  .desk-switcher .desk-column__badge {\n    line-height: 16px;\n    padding: 1px 7px;\n  }\n\n  .desk-card .ant-btn {\n    min-height: 40px;\n  }\n\n  .desk-card .desk-card__icon-btn {\n    min-width: 40px;\n  }\n\n  .desk-card__actions {\n    gap: var(--ds-space-1);\n  }\n}\n\n/* ── Tablets and up ───────────────────────────────────────── */\n@media (min-width: 768px) {\n  .desk-wrapper {\n    padding: var(--ds-space-5);\n  }\n\n  .desk-wrapper--embedded {\n    padding: 0;\n  }\n\n  .desk-board {\n    gap: var(--ds-space-4);\n    scroll-snap-type: x proximity;\n  }\n\n  .desk-column {\n    flex: 0 0 300px;\n    max-width: none;\n  }\n}\n\n/* Wide screens: all four columns fit, so they share the width. */\n@media (min-width: 1200px) {\n  .desk-board {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    overflow: visible;\n    padding-bottom: 0;\n  }\n\n  .desk-board:not(.desk-board--fit) {\n    align-items: start;\n  }\n}\n\n/* Hover lift only where there is a pointer that hovers. */\n@media (hover: hover) {\n  .desk-card:hover {\n    box-shadow: var(--ds-shadow-md);\n    transform: translateY(-1px);\n  }\n\n  .desk-card__actions .desk-card__icon-btn:hover {\n    color: var(--ds-brand-strong);\n  }\n\n  .desk-card__actions .desk-card__icon-btn.ant-btn-dangerous:hover {\n    color: var(--ds-danger);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
